import React, { useContext } from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Switch
} from '@mui/material';
import FormContext from '../FormContext';

type PropsType = {
    name: string,
    label: string,
    value: boolean,
    variant?: 'switch',
    helperText?: string,
    disabled?: boolean,
    sx?: {[key: string]: string | number },
    onChange: (a: any) => void
};

const BoolField: React.FC<PropsType> = (props) => {
    const {
        name,
        label,
        value,
        variant,
        helperText = '',
        disabled,
        sx,
        onChange
    } = props;

    const formContext = useContext(FormContext);
    const isSubmitting = formContext?.isSubmitting;

    const handleChange = React.useCallback((e) => {
        onChange({ [name]: e.target.checked });
    }, [name, onChange]);

    return (
        <FormControl component="fieldset" variant="standard">
            <FormGroup>
                <FormControlLabel
                    label={label}
                    disabled={disabled || isSubmitting}
                    sx={{
                        alignItems: 'flex-start',
                        marginTop: 0,
                        marginBottom: 0,
                        '& .MuiFormControlLabel-label': {
                            lineHeight: 1.3
                        },
                        '& .MuiCheckbox-root, & .MuiSwitch-root': {
                            mt: -0.25,
                            pt: 0
                        }
                    }}
                    control={
                        variant === 'switch'
                            ? <Switch checked={!!value} name={name} onChange={handleChange} sx={sx} />
                            : <Checkbox checked={!!value} name={name} onChange={handleChange} sx={sx} />
                    }

                />
            </FormGroup>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
};

export default BoolField;
